<template>
  <div class="content" v-loading="loading">
    <div class="top">
      <!-- <span class="label">所属区域：</span>
      <el-select
        style="width:130px;"
        v-model="province"
        filterable
        size="mini"
        placeholder="省份"
        @change="onChangeProvince"
      >
        <el-option
          v-for="item in provinceList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-select
        style="width:130px;"
        v-model="city"
        filterable
        size="mini"
        placeholder="市"
        @change="onChangeCity"
      >
        <el-option
          v-for="item in cityList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-select
        style="width:130px;"
        v-model="area"
        filterable
        size="mini"
        placeholder="区"
      >
        <el-option
          v-for="item in areaList"
          :key="item.id"
          :label="item.name"
          :value="item.areaCode"
        ></el-option>
      </el-select> -->

      <span class="label" style="margin-left:12px">账号状态：</span>
      <el-select
        style="width:130px;"
        v-model="form.pay_type"
        filterable
        size="mini"
        placeholder="全部"
      >
        <el-option label="全部" value="0"></el-option>
        <el-option label="已启用" value="1"></el-option>
        <el-option label="已禁用" value="2"></el-option>
      </el-select>
      <el-button
        style="float:right"
        type="primary"
        size="mini"
        @click="searchData"
        >搜索</el-button
      >
      <el-input
        style="width:200px;float:right;margin-right:8px"
        v-model="form.shop_name"
        size="mini"
        clearable
        placeholder="输入商户名称搜索"
      ></el-input>
    </div>

    <el-table
      :data="tableData"
      class="table"
      max-height="600"
      :cell-style="tc"
      :header-cell-style="tccolor"
    >
      <el-table-column prop="id" label="ID" width="100"></el-table-column>
      <!-- <el-table-column label="头像" width="100">
        <template slot-scope="scope">
          <img
            class="avatar"
            :src="
              scope.row.user && scope.row.user.wxheadpic
                ? scope.row.user.wxheadpic
                : scope.row.shop_icon
            "
          />
        </template>
      </el-table-column> -->
      <!-- <el-table-column label="昵称" width="140">
        <template slot-scope="scope">
          {{
            scope.row.user && scope.row.user.wxnickname
              ? scope.row.user.wxnickname
              : scope.row.shop_name
          }}
        </template>
      </el-table-column> -->
      <el-table-column label="商户名称" prop="shop_name"></el-table-column>
      <el-table-column label="管理账号" width="140">
        <template slot-scope="scope">
          {{
            scope.row.user && scope.row.user.mobile
              ? scope.row.user.mobile
              : scope.row.user.mobile
          }}
        </template>
      </el-table-column>
      <el-table-column label="商户区域" prop="address">
        <template slot-scope="scope">
          <!-- {{scope.row.province}}.{{scope.row.city}}.{{scope.row.district}} -->
          {{scope.row.address}}
        </template>
      </el-table-column>
      <el-table-column label="首次入驻时间" prop="create_time"></el-table-column>
      <el-table-column label="商户类型">
        <template slot-scope="scope">
          <p v-if="scope.row.shop_type == 2">线上商户</p>
          <p v-if="scope.row.shop_type == 1">BC联盟</p>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="展示状态" width="120">
        <template slot-scope="scope">
          <el-switch
            style="margin-right:8px"
            :key="scope.row.id"
            :active-value="0"
            :inactive-value="1"
            :value="scope.row.status"
            @change="onSwitchChange(scope.row, $event)"
          ></el-switch
          >{{ Number(scope.row.status) === 0 ? '开启' : '隐藏' }}
        </template>
      </el-table-column>
      <!-- <el-table-column label="可用红包" width="140">
        <template slot-scope="scope">{{
          scope.row.red_picket ? scope.row.red_picket.balance_tlj : '0.00'
        }}</template>
      </el-table-column> -->
      <el-table-column label="操作" fixed="right" width="240">
        <template slot-scope="scope">
          <el-button size="mini" @click="onDetailClick(scope.row)"
            >详情</el-button
          >
          <!-- <el-button
            size="mini"
            type="primary"
            @click="onRechargeClick(scope.row.mobile)"
            >充值红包</el-button
          > -->
        </template>
      </el-table-column>
    </el-table>

    <el-col :span="24">
      <div class="pagination">
        <el-pagination
          background
          @current-change="pageChange"
          :current-page="form.page"
          :page-size="form.size"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </el-col>
    <jdialog
      title="充值红包"
      :visible.sync="rechargeDialogVisible"
      width="640px"
    >
      <div class="recharge-box" v-loading="rechargeDialogLoading">
        <p class="tip">
          提示：红包充值成功后，账号中对应增加充值金额，已充值红包不可回收
        </p>
        <el-form
          :model="rechargeForm"
          :rules="rechargeRule"
          label-width="100px"
          ref="rechargeForm"
        >
          <el-form-item label="充值金额：" prop="money">
            <el-input
              class="input-hb"
              v-model="rechargeForm.money"
              type="number"
              min="0"
              placeholder="输入红包充值金额"
            >
            </el-input>
            <span>元</span>
          </el-form-item>
          <el-form-item class="btns">
            <el-button type="primary" @click="onConfirmRecharge"
              >确定</el-button
            >
            <el-button type="info" @click="rechargeDialogVisible = false"
              >取消</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </jdialog>
    <!-- <UserInfoDialog :visible.sync="detailDialogVisible" :mobile="tempMobile" /> -->


    <jdialog title="线上商家信息" :visible.sync = 'showOnlineInfo' width='540px'>
      <p style="color:red;padding:20px 20px 0px 20px;">服务有效期至:{{service_end_time}}-12:00:00</p>
      <el-form v-model="detailForm" style="padding:20px;">
        <el-form-item label="商户名称:">
          <el-input size="mini" v-model="detailForm.shop_name" disabled style="width:240px;">
         
          </el-input>
        </el-form-item>
        <el-form-item label="联系人:" >
           <el-input size="mini" style="width:240px;" disabled v-model="detailForm.contact"></el-input>
        </el-form-item>
        <el-form-item label="联系电话:" >
           <el-input size="mini" style="width:240px;" disabled v-model="detailForm.phone"></el-input>
        </el-form-item>
        <el-form-item label="营业执照:">
                <uploadImg flieName="company_license"
            class="icon_cate"
            aria-disabled="true"
            :oldImgs="[detailForm.company_license]"
            :n="1"
            @getFile="getFile"></uploadImg>
        </el-form-item>
      </el-form>

      <div style="text-align:center;">
        <el-button size="mini" @click="cancelShowDetailInfo">取消</el-button>
        <el-button size="mini" @click="certainDetailInfo">确定</el-button>
      </div>
    </jdialog>
  </div>
</template>

<script>
import { getOnlinBusiness, rechargeHb } from '@/api/managent'
import uploadImg from "@/components/uploadImg";
// import { provinceCityArea } from '@/api/goods'
// import UserInfoDialog from './userInfoDialog'
export default {
  components: { uploadImg },
  data() {
    return {
      loading: false,
      detailDialogVisible: false,
      rechargeDialogVisible: false,
      rechargeDialogLoading: false,
      province: '',
      city: '',
      area: '',
      form: {
        shop_name: '',
        // city_area: '',
        // adcode: '',
        page: 1,
        size: 20
      },
      rechargeForm: {
        money: 0,
        mobile: ''
      },
      rechargeRule: {
        money: [
          { required: true, message: '输入红包充值金额', trigger: 'blur' }
        ]
      },
      provinceList: [],
      cityList: [],
      areaList: [],
      tableData: [],
      total: 999,
      tempMobile: '',

      showOnlineInfo:false,
      detailForm:{
        company_license:'',
        //联系人
        contact:'',
        //联系电话
        phone:'',
        //小店名称
        shop_name:''
      },
      service_end_time:'',
    }
  },
  mounted() {},
  created() {
    // this.getProvinceDataList('1', '0')
    this.getListData()
  },
  methods: {
    certainDetailInfo(){
      this.showOnlineInfo = false
    },
    cancelShowDetailInfo(){
      this.showOnlineInfo  = false
    },

    getFile (file) {
      this.detailForm[file.name] = file.files.length > 0 ? file.files[0].url : "";
    },
    tc() {
      return 'text-align:center; color:#333333; font-size:12px;'
    },
    tccolor() {
      return 'text-align:center;background-color:#f5f5f5; font-size:14px;'
    },
    // onChangeProvince(e) {
    //   //切换省,同时获取省对应的城市 e是城市对应的id

    //   this.province = e
    //   //后面加获取对应省的城市接口
    //   this.city = ''
    //   this.area = ''
    //   this.getProvinceDataList('2', e)
    // },
    // onChangeCity(e) {
    //   this.city = e
    //   this.area = ''
    //   //获取对应城市的区
    //   this.getProvinceDataList('3', e)
    // },
    //搜索
    searchData() {
      this.getListData()
    },

    //获取省列表
    // async getProvinceDataList(t, p) {
    //   let res = await provinceCityArea({ type: t, pid: p })
    //   if (res.code === 10000) {
    //     if (t === '1') {
    //       this.provinceList = res.data
    //     } else if (t === '2') {
    //       this.cityList = res.data
    //     } else {
    //       this.areaList = res.data
    //     }
    //   }
    // },
    pageChange(page) {
      this.form.page = page
      this.getListData()
    },
    //获取小店列表
    getListData() {
      // if (
      //   (this.province && !this.city) ||
      //   (this.province && !this.area && !this.city)
      // ) {
      //   this.$message.error('市或区不能为空')
      //   return
      // }
      // if (this.area) {
      //   this.form.city_area = 3
      //   this.form.adcode = this.area
      // } else if (this.city) {
      //   this.form.city_area = 2
      //   this.form.adcode = this.city
      // } else {
      //   this.form.city_area = 0
      //   this.form.adcode = ''
      // }
      getOnlinBusiness(this.form).then(res => {
        if (res.code === 10000) {
          this.tableData = res.data.data || []
          this.total = res.data.total
        } else {
          this.$message.error(res.message)
        }
        this.loading = false
      })
    },
    onSwitchChange(item, e) {
      item.status = e
    },
    onDetailClick(row) {
      // this.tempMobile = mobile
      // this.detailDialogVisible = true

      this.detailForm.company_license = row.company_license
      this.detailForm.contact  = row.contact
      this.detailForm.phone =  row.user.mobile
      this.detailForm.shop_name = row.shop_name
      this.service_end_time  =  row.service_time_end
      this.showOnlineInfo =  true
    },
    onRechargeClick(mobile) {
      this.rechargeForm.mobile = mobile
      this.rechargeDialogVisible = true
    },
    onConfirmRecharge() {
      this.$refs.rechargeForm.validate(valid => {
        if (valid) {
          this.rechargeDialogLoading = true
          rechargeHb(this.rechargeForm).then(res => {
            if (res.code === 10000) {
              this.$message.success('充值成功')
              this.detailDialogVisible = false
              this.form.page = 1
              this.getListData()
            } else {
              this.$message.error(res.message)
            }
            this.rechargeDialogLoading = false
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  padding: 20px;
  .top {
    margin-bottom: 20px;
  }
  .table {
    width: 100%;
    padding: 0 20px;
    .avatar {
      width: 48px;
      height: 48px;
      object-fit: cover;
    }
  }

  .pagination {
    float: right;
    margin-top: 12px;
  }
  .recharge-box {
    .tip {
      margin: 16px;
    }
    .input-hb {
      width: 400px;
      margin-right: 12px;
    }
    .btns {
      margin-top: 50px;
      margin-bottom: 20px;
      display: flex;
      justify-content: center;
    }
  }
}
</style>
